import { ENDPOINTS } from "../constants/endpoints";
import axiosClient from "./axiosClient.service";

export function getDataPipeline() {
    return axiosClient.get(ENDPOINTS.GET_DATA_PIPELINES)
}